import styled from 'styled-components'

export const AllLevelsNotifHeader = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.colors.brandPrimary};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  text-align: center;
`

export const AllLevelsNotifSubHeader = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  letter-spacing: 0.49px;
  line-height: 1.14;
  text-align: center;
`

export const AllLevelsNotifContent = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  text-align: center;
  line-height: 16px;
  letter-spacing: 0.49px;
`
